import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  Output,
  ViewEncapsulation,
  QueryList,
} from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../common/components/base.component';
import { PlaceType } from '../place.category/customize.place.category.component';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { clone } from '../../../common/extensions';
import { CustomDefaultPlaceCategoryItemSelectionStore } from '../../../stores/hub.calendar.store';
import { CustomDefaultPlaceCategory } from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { AllFrontendSettingsStore, VisitorDataCache } from '../../../stores/visitor.calendar.store';
import { HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { $e } from '@angular/compiler/src/chars';
import { NestedMenusComponent } from '../../../common/components/nested.menu/nested.menu.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { PlaceService } from '../../../services/place.service';
import { AccordionEditorComponent } from '../accordion.editor/accordion.editor.component';

@Component({
  selector: 'ig-custom-default-place-category-accordion',
  templateUrl: './custom.default.place.category.accordion.component.html',
  styleUrls: ['./custom.default.place.category.accordion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomDefaultPlaceCategoryAccordionComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public initialCategoryForCustomInUrlMode: string;
  public loadingToggles = false;

  @ViewChild('accordion') accordion: AccordionComponent;
  @ViewChild('customDefaultPlaceBtn') customDefaultPlaceBtn: NestedMenusComponent;
  @Input() public selectedCategory = 'All';
  @Input() public menuType: 'custom' | 'default' = 'default';
  @Input() public customDefaultPlaceCategory: CustomDefaultPlaceCategory;
  @Input() public title = 'FILTER BY CATEGORY';
  @Input() public toggleAndSource = new HubVisitorToggleDataSource();
  @Input() public menuMode: 'sidebar' | 'topbar' = 'sidebar';
  @Input() public useNonLeafMenuClick: boolean = false;

  @Output() onCategoryClick: EventEmitter<PlaceType> = new EventEmitter<PlaceType>();
  @Output() onNormalCategoryClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() onNonLeafClick: EventEmitter<PlaceType> = new EventEmitter<PlaceType>();

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private customDefaultPlaceCategoryItemSelectionStore: CustomDefaultPlaceCategoryItemSelectionStore
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName, menuType } = this.allRouteParams;
    this.hubName = hubName;
    setTimeout(() => {
      if (this.selectedCategory && this.selectedCategory !== 'All') {
        if (this.menuType === 'custom') {
          this.initialCategoryForCustomInUrlMode = this.selectedCategory;
        }
        this.setFilter(this.selectedCategory);
      }
    }, 1600);
  }

  public get isShowThingsToDo() {
    return (
      !this.loadingToggles &&
      (this.toggleAndSource.toggle.placeCategory.activity ||
        this.toggleAndSource.toggle.placeCategory.art ||
        this.toggleAndSource.toggle.placeCategory.outdoor ||
        this.toggleAndSource.toggle.placeCategory.entertainment)
    );
  }

  public isSelected(title: string) {
    return this.selectedCategory === title;
  }

  public selectCustomDefaultPlaceCategory($event: PlaceType | string) {
    // selected 'all'
    if (typeof $event === 'string') {
      if (this.menuType !== 'custom') {
        localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
        this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
      } else {
        this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.setFilter(this.initialCategoryForCustomInUrlMode);
      }
      this.filterPlace($event);
    } else {
      let categoryList: string[] = [];
      PlaceService.getAllSubCategories($event, categoryList);
      $event.categoryList = categoryList;

      this.selectedCategory = $event.title;
      this.setFilter($event.title);

      // for map view
      delete $event['subMenuEleRef'];
      const data =
        this.menuType === 'custom'
          ? $event
          : {
              title: $event.title,
              categoryList: $event.categoryList,
            };
      // localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(data));

      this.onCategoryClick.emit($event);
    }
  }

  public nonLeafClick(node: PlaceType) {
    if (this.useNonLeafMenuClick) {
      let categoryList: string[] = [];
      PlaceService.getAllSubCategories(node, categoryList);
      node.categoryList = categoryList;
      this.close();
      this.onNonLeafClick.emit(node);
    }
  }

  public filterPlace($event: string) {
    
    this.selectedCategory = $event;
    this.onNormalCategoryClick.emit($event);
    
    if ($event === 'All') {
      // for changing the selection style
      this.customDefaultPlaceCategoryItemSelectionStore.CustomDefaultPlaceCategoryItemSelectionCommand.next($event);

      if (this.menuType !== 'custom') {
        this.accordion && this.accordion.clearFilter(null, false);
        localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
      }
    } else {
      this.accordion && this.accordion.setFilter($event);
      localStorage.setItem(localStorageKeys.selectedPlaceCategory, $event);
    }
    this.menuMode === 'topbar' && this.accordion && this.accordion.close();
  }

  public setFilter(title: string) {
    if (!title) {
      this.clearFilter();
      return;
    }
    const category = PlaceService.getCustomDefaultPlaceCategoryById(title, this.customDefaultPlaceCategory);
    // const category = this.customDefaultPlaceCategory.customCategories.find(
    //     (x) => x.title === title || x._id === title
    // );
    if (category) {
      this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.setFilter(category.title);
      this.accordion && this.accordion.setFilter(category.title);
    }
  }

  public clearFilter() {
    this.customDefaultPlaceBtn && this.customDefaultPlaceBtn.clearFilter();
    this.accordion && this.accordion.clearFilter(null, false);
  }

  public close() {
    this.accordion && this.accordion.close();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/custom.default.place.category.accordion/custom.default.place.category.accordion.component..ts